import { SliderType } from './SliderType';

export interface SliderSlide {
  id: number;
  path: string;
  url?: string;
  type: SliderType;
}

export const sliderSlideFromResponse = (responseData: any): SliderSlide => ({
  id: responseData.id,
  path: responseData.path,
  url: responseData.url,
  type: responseData.type || 'all',
});
